module.exports = __webpack_public_path__ + "static/york-46035c58313f97cfcf70cc54e7f5c3a6.png";